import SettingsItem from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItem";
import SettingsItemText from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";
import { useEditor, useNode } from "@craftjs/core";
import { Grid } from "@mui/material";

const Settings = () => {
    const { id } = useNode();
    const { displayName, anchorTag, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
        anchorTag: state.nodes[id].data.props.anchorTag,
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection title="Anchor" summary={() => ""}>
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={anchorTag}
                        onChange={(value: string) => {
                            actions.setProp(id, (props) => (props.anchorTag = value));
                        }}
                        fullWidth={true}
                        label="Tag (optional)"
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection
                title="Margin"
                props={["margin"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ margin }: any) => {
                    return `${margin[0] || 0}px ${margin[1] || 0}px ${margin[2] || 0}px ${margin[3] || 0}px`;
                }}
            >
                <SettingsItem propKey="margin" index={0} type="slider" label="Top" />
                <SettingsItem propKey="margin" index={1} type="slider" label="Right" />
                <SettingsItem propKey="margin" index={2} type="slider" label="Bottom" />
                <SettingsItem propKey="margin" index={3} type="slider" label="Left" />
            </SettingsSection>
        </>
    );
};

export default Settings;
